<template>
  <v-row justify="center">
    <v-dialog v-model="open" width="1360" transition="scroll-x-transition">
      <v-card height="700px">
        <v-row no-gutters>
          <v-col cols="5">
            <v-card
              class="illustration-container"
              color="#5D85F8"
              tile
              height="700px"
              width="100%"
            >
              <img class="circle-bottom" src="../../assets/login-circle.svg" />
              <img class="circle-top" src="../../assets/login-circle.svg" />
              <img class="dots-vertical" src="../../assets/login-points.svg" />
              <img
                class="dots-horizontal"
                src="../../assets/login-points.svg"
              />
              <v-col cols="10">
                <v-row class="pt-11 mt-12">
                  <span class="cardPlanText mb-4">Produtos selecionados:</span>
                  <v-card
                    class="mb-8 rounded-xl"
                    width="440"
                    height="240"
                    color="white"
                    elevation="8"
                  >
                    <v-row no-gutters class="pt-6 pl-6">
                      <v-col cols="12" class="mb-1 pr-6">
                        <v-row
                          no-gutters
                          align="center"
                          justify="space-between"
                        >
                          <span class="planText text-uppercase">{{
                            plan.title
                          }}</span>
                          <span>R$ {{ plan.price }}</span>
                        </v-row>
                      </v-col>
                      <v-col cols="12" class="mb-1">
                        <span class="cardPlanAttributes">
                          <v-avatar color="lighter" size="20" class="mr-2">
                            <v-icon size="14" color="primary"
                              >mdi-database</v-icon
                            >
                          </v-avatar>
                          {{ calcBytes(plan.storage) }}
                          {{ $t('message.ofStorage') }}
                        </span>
                      </v-col>
                      <v-col cols="12" class="mb-1">
                        <span class="cardPlanAttributes">
                          <v-avatar color="lighter" size="20" class="mr-2">
                            <v-icon size="14" color="primary"
                              >mdi-swap-horizontal</v-icon
                            >
                          </v-avatar>
                          {{ calcBytes(plan.traffic) }}
                          {{ $t('message.ofTraffic') }}
                        </span>
                      </v-col>
                      <v-col
                        cols="12"
                        class="mb-1 pr-6"
                        v-if="this.addons.storage.addonAdicionalStorage > 1"
                      >
                        <v-row
                          no-gutters
                          align="center"
                          justify="space-between"
                        >
                          <span class="cardPlanAttributes">
                            <v-avatar color="lighter" size="20" class="mr-2">
                              <v-icon size="14" color="primary"
                                >mdi-database-plus</v-icon
                              >
                            </v-avatar>
                            <small
                              v-if="
                                this.addons.storage.addonAdicionalStorage > 1
                              "
                              >{{
                                `+${this.addons.storage.addonAdicionalStorage} GB de armazenamento adicional`
                              }}</small
                            >
                          </span>
                          <span>R$ {{ this.addons.storage.price }}.00</span>
                        </v-row>
                      </v-col>
                      <v-col
                        cols="12"
                        class="pr-6"
                        v-if="this.addons.traffic.addonAdicionalTraffic > 1"
                      >
                        <v-row
                          no-gutters
                          align="center"
                          justify="space-between"
                        >
                          <span class="cardPlanAttributes">
                            <v-avatar color="lighter" size="20" class="mr-2">
                              <v-icon size="14" color="primary"
                                >mdi-swap-horizontal</v-icon
                              >
                            </v-avatar>
                            <small
                              v-if="
                                this.addons.traffic.addonAdicionalTraffic > 1
                              "
                              >{{
                                `+${this.addons.traffic.addonAdicionalTraffic} GB de tráfego adicional`
                              }}</small
                            >
                          </span>
                          <span> R$ {{ this.addons.traffic.price }}.00 </span>
                        </v-row>
                      </v-col>
                      <v-col cols="12" class="mt-5">
                        <v-divider class="mr-6 mb-2" />
                        <span class="cardPriceText">
                          <span>Subtotal: </span>
                          {{
                            this.addonsPrice > 1
                              ? `R$${parseFloat(plan.price) + addonsPrice}0`
                              : `R$${plan.price}`
                          }}
                          <span v-if="plan.storage < 11" class="cardByTime"
                            >/{{ $t('message.byYear') }}</span
                          >
                          <span v-else class="cardByTime"
                            >/{{ $t('message.byMonth') }}</span
                          >
                        </span>
                      </v-col>
                    </v-row>
                  </v-card>
                  <v-btn outlined color="white" @click="handleBackButton">
                    <v-icon small class="mr-4">mdi-arrow-left</v-icon>
                    {{ backButtonText }}
                  </v-btn>
                </v-row>
              </v-col>
            </v-card>
          </v-col>
          <v-col cols="7" v-if="aditionalStep">
            <customize-plan :plan="this.plan" />
          </v-col>
          <v-col cols="7" v-else>
            <template v-if="!purchaseDone">
              <v-row no-gutters justify="center" align="center">
                <template v-if="!isFetching">
                  <template
                    v-if="!errors.userDataError && !errors.cardInfoError"
                  >
                    <v-col cols="12">
                      <v-row no-gutters justify="end" align="end">
                        <v-btn icon class="mt-2 mr-3" @click="handleClose">
                          <v-icon color="icon">mdi-close</v-icon>
                        </v-btn>
                      </v-row>
                    </v-col>
                    <v-col cols="6">
                      <v-stepper
                        v-model="stepper.step"
                        alt-labels
                        class="elevation-0"
                      >
                        <v-stepper-header>
                          <v-stepper-step
                            v-if="!hasTaxid"
                            :complete="stepper.step >= 0"
                            step=""
                            complete-icon=""
                            color="primary"
                          >
                            <span class="caption">{{
                              $t('message.pages.checkout.personalData')
                            }}</span>
                          </v-stepper-step>

                          <v-divider v-if="!hasTaxid" />

                          <v-stepper-step
                            :complete="stepper.step > 0"
                            step=""
                            complete-icon=""
                            color="primary"
                          >
                            <span class="caption">{{
                              $t('message.address')
                            }}</span>
                          </v-stepper-step>

                          <v-divider></v-divider>

                          <v-stepper-step
                            :complete="stepper.step > 1"
                            step=""
                            complete-icon=""
                            color="primary"
                          >
                            <span class="caption">{{
                              $t('message.pages.checkout.payment')
                            }}</span>
                          </v-stepper-step>
                        </v-stepper-header>
                      </v-stepper>
                    </v-col>
                    <v-col cols="8">
                      <span class="text-h5"
                        ><b>{{ $t('message.paymentDetails') }}</b></span
                      >
                    </v-col>
                    <v-col cols="8">
                      <span class="subtitleText"
                        >{{
                          $t('message.pages.checkout.fillInFieldsBelow')
                        }}.</span
                      >
                    </v-col>
                    <template v-if="stepper.step === 0 && !hasTaxid">
                      <v-col cols="8" class="my-7">
                        <v-row no-gutters align="center" justify="center">
                          <span class="sectionText">{{
                            $t('message.pages.checkout.personalData')
                          }}</span>
                          <v-divider class="ml-2" />
                        </v-row>
                      </v-col>
                      <v-col cols="8">
                        <v-row no-gutters justify="space-between">
                          <v-col cols="12">
                            <v-text-field
                              v-model="owner.name"
                              class="mt-2"
                              :label="$t('message.pages.checkout.fullName')"
                              single-line
                              :placeholder="
                                $t('message.pages.checkout.insertYourName')
                              "
                              outlined
                              dense
                              required
                            >
                              <template v-slot:prepend-inner>
                                <v-icon color="icon">mdi-account</v-icon>
                              </template>
                            </v-text-field>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="8">
                        <v-row no-gutters justify="space-between">
                          <v-col cols="12">
                            <v-card height="70px" flat>
                              <v-text-field
                                v-model="owner.document"
                                class="mt-2"
                                label="CPF ou CPNJ"
                                placeholder="CPF ou CPNJ"
                                v-mask="[
                                  '###.###.###-##',
                                  '##.###.###/####-##',
                                ]"
                                outlined
                                dense
                                required
                                :messages="documentErrorMessage"
                                :error="errors.invalidCnpj || errors.invalidCpf"
                              >
                                <template v-slot:message="{ message }">
                                  <span
                                    class="red--text caption align-text"
                                    v-if="
                                      errors.invalidCnpj || errors.invalidCpf
                                    "
                                  >
                                    <v-icon color="red" size="18" class="pb-1">
                                      mdi-alert-circle</v-icon
                                    >
                                    {{ message }}
                                  </span>
                                </template>
                                <template v-slot:prepend-inner>
                                  <v-icon color="icon">mdi-account</v-icon>
                                </template>
                              </v-text-field>
                            </v-card>
                          </v-col>
                          <v-col cols="12">
                            <v-text-field
                              v-model="owner.phone"
                              class="mt-2"
                              v-mask="['(##) ####-####', '(##) #####-####']"
                              :label="$t('message.pages.checkout.phone')"
                              :placeholder="
                                $t('message.pages.checkout.insertYourPhone')
                              "
                              outlined
                              dense
                            >
                              <template v-slot:prepend-inner>
                                <v-icon color="icon">mdi-account</v-icon>
                              </template>
                            </v-text-field>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="8" class="mt-12">
                        <v-btn
                          block
                          color="primary"
                          large
                          :disabled="isFetchingUserDetails"
                          :loading="isFetchingUserDetails"
                          @click="addUserToStripe"
                          >{{ $t('message.pages.checkout.proceed') }}</v-btn
                        >
                      </v-col>
                      <v-col cols="8" class="my-5">
                        <v-row no-gutters justify="center" align="center">
                          <v-icon class="mr-1" color="icon" small
                            >mdi-lock</v-icon
                          >
                          <span class="safeText">{{
                            $t('message.pages.checkout.safePayment')
                          }}</span>
                        </v-row>
                      </v-col>
                    </template>
                    <v-row
                      no-gutters
                      justify="center"
                      v-if="stepper.step === 1"
                    >
                      <v-col cols="8" class="my-7">
                        <v-row no-gutters align="center" justify="center">
                          <span class="sectionText">{{
                            $t('message.address')
                          }}</span>
                          <v-divider class="ml-2" />
                        </v-row>
                      </v-col>
                      <v-col cols="8">
                        <v-row no-gutters justify="space-between">
                          <v-col cols="8">
                            <v-text-field
                              v-model="owner.address.postal_code"
                              v-mask="'#####-###'"
                              label="CEP"
                              placeholder="Ex: 12345000"
                              outlined
                              dense
                              required
                              maxlength="9"
                              @keydown.enter="searchCep"
                            >
                              <template v-slot:prepend-inner>
                                <v-icon color="icon">mdi-map-marker</v-icon>
                              </template>
                            </v-text-field>
                          </v-col>
                          <v-col cols="4">
                            <v-btn
                              class="ml-3"
                              width="150"
                              height="40"
                              color="primary"
                              :loading="validatingCEP"
                              :disabled="validatingCEP"
                              @click="searchCep"
                            >
                              {{ $t('message.pages.checkout.search') }}
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="8">
                        <span>{{ $t('message.address') }}</span>
                        <v-text-field
                          v-model="owner.address.line1"
                          placeholder="Rua exemplo"
                          outlined
                          dense
                          required
                        >
                          <template v-slot:prepend-inner>
                            <v-icon color="icon">mdi-home</v-icon>
                          </template>
                        </v-text-field>
                      </v-col>
                      <v-col cols="8">
                        <v-row no-gutters justify="space-between">
                          <v-col cols="12">
                            <v-text-field
                              v-model="owner.address.line2"
                              placeholder="Apartamento, sala, edifício, andar, etc."
                              outlined
                              dense
                              required
                            >
                              <template v-slot:prepend-inner>
                                <v-icon color="icon">mdi-home</v-icon>
                              </template>
                            </v-text-field>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="8">
                        <v-row no-gutters justify="space-between">
                          <v-col cols="7" class="pr-2">
                            <v-text-field
                              v-model="owner.address.city"
                              :label="$t('message.city')"
                              :placeholder="$t('message.city')"
                              outlined
                              dense
                              required
                            >
                            </v-text-field>
                          </v-col>
                          <v-col cols="5" class="pl-2">
                            <v-text-field
                              v-model="owner.address.state"
                              :label="$t('message.state')"
                              :placeholder="$t('message.state')"
                              dense
                              outlined
                            ></v-text-field>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="8" class="mt-8">
                        <v-btn
                          block
                          color="primary"
                          large
                          :disabled="
                            validatingCEP ||
                            isFetchingAddress ||
                            !secondStepForm
                          "
                          :loading="isFetchingAddress"
                          @click="addAddressToUser"
                          >{{ $t('message.pages.checkout.proceed') }}</v-btn
                        >
                      </v-col>
                      <v-col cols="8" class="my-5">
                        <v-row no-gutters justify="center" align="center">
                          <v-icon class="mr-1" color="icon" small
                            >mdi-lock</v-icon
                          >
                          <span class="safeText">{{
                            $t('message.pages.checkout.safePayment')
                          }}</span>
                        </v-row>
                      </v-col>
                    </v-row>
                    <template v-if="stepper.step === 2">
                      <v-col cols="8" class="my-7">
                        <v-row no-gutters align="center" justify="center">
                          <span class="sectionText">{{
                            $t('message.pages.checkout.payment')
                          }}</span>
                          <v-divider class="ml-2" />
                        </v-row>
                      </v-col>
                      <v-col cols="8">
                        <v-row no-gutters justify="space-between">
                          <v-col cols="12">
                            <v-card width="100%" height="220px" tile flat>
                              <v-card
                                flat
                                v-if="newCard || !card || cards.length < 1"
                              >
                                <v-col cols="12" class="pa-0 pt-4">
                                  <span>Cartão</span>
                                  <stripe-element-card
                                    key="stripeCard"
                                    id="stripeCard"
                                    class="pt-4"
                                    ref="elementRef"
                                    :hidePostalCode="true"
                                    :pk="stripeKey"
                                    @token="handleToken"
                                  />
                                </v-col>
                                <v-col cols="12" class="pa-0 ma-0">
                                  <v-row no-gutters>
                                    <v-col cols="12">
                                      <v-card height="30px" width="100%" flat>
                                        <span
                                          class="red--text caption align-text"
                                          v-if="
                                            cardErrors.declined ||
                                            cardErrors.default ||
                                            cardErrors.expired
                                          "
                                        >
                                          <v-icon
                                            color="red"
                                            size="18"
                                            class="pb-1"
                                          >
                                            mdi-alert-circle
                                          </v-icon>
                                          {{ cardErrorMsg }}
                                        </span>
                                        <span
                                          class="red--text caption align-text"
                                          v-if="errors.subscriptionError"
                                        >
                                          <v-icon
                                            color="red"
                                            size="18"
                                            class="pb-1"
                                          >
                                            mdi-alert-circle
                                          </v-icon>
                                          {{
                                            $t(
                                              'message.pages.checkout.errors.subscriptionError'
                                            )
                                          }}
                                        </span>
                                      </v-card>
                                    </v-col>
                                    <v-spacer />
                                    <v-col
                                      cols="12"
                                      class="d-flex flex-row align-end justify-end"
                                    >
                                      <v-spacer />
                                      <v-btn
                                        v-if="cards.length > 0"
                                        text
                                        @click="handleCancelAddCard"
                                      >
                                        {{
                                          $t(
                                            'message.pages.checkout.changeCard'
                                          )
                                        }}
                                      </v-btn>
                                    </v-col>
                                  </v-row>
                                </v-col>
                              </v-card>
                              <template v-else>
                                <span>{{
                                  $t('message.pages.checkout.card')
                                }}</span>
                                <v-select-legacy
                                  v-model="card"
                                  item-color="white"
                                  class="mt-4 selectTemplate2"
                                  solo
                                  flat
                                  no-data-text=""
                                  :items="cards"
                                  content
                                  :menu-props="{
                                    offsetY: true,
                                    contentClass: 'selectTemplate',
                                  }"
                                >
                                  <template v-slot:selection="{ item }">
                                    <v-card
                                      class="d-flex flex-row align-center justify-space-between"
                                      width="485px"
                                      height="75px"
                                      outlined
                                    >
                                      <v-row no-gutters>
                                        <template
                                          v-if="
                                            item.brand === 'MasterCard' ||
                                            item.brand === 'Visa'
                                          "
                                        >
                                          <img
                                            v-if="item.brand === 'MasterCard'"
                                            class="mx-3"
                                            src="@/assets/mastercardLogo.svg"
                                          />
                                          <img
                                            v-if="item.brand === 'Visa'"
                                            class="mx-3"
                                            src="@/assets/visaCard.svg"
                                          />
                                        </template>
                                        <template v-else>
                                          <v-icon
                                            size="48"
                                            class="mx-3"
                                            color="primary"
                                          >
                                            mdi-credit-card-outline
                                          </v-icon>
                                        </template>
                                        <v-col>
                                          <span
                                            >{{
                                              item.funding === 'credit'
                                                ? 'Crédito'
                                                : 'Débito'
                                            }}
                                            {{ item.brand }}</span
                                          >
                                          <br />
                                          <span class="cardText"
                                            >**** **** ****
                                            {{ item.last4 }}</span
                                          >
                                        </v-col>
                                      </v-row>
                                    </v-card>
                                  </template>
                                  <template v-slot:item="{ item }">
                                    <v-card
                                      class="d-flex flex-row align-center justify-space-between"
                                      width="100%"
                                      height="75px"
                                      tile
                                    >
                                      <v-row no-gutters>
                                        <template
                                          v-if="
                                            item.brand === 'MasterCard' ||
                                            item.brand === 'Visa'
                                          "
                                        >
                                          <img
                                            v-if="item.brand === 'MasterCard'"
                                            class="mx-3"
                                            src="@/assets/mastercardLogo.svg"
                                          />
                                          <img
                                            v-if="item.brand === 'Visa'"
                                            class="mx-3"
                                            src="@/assets/visaCard.svg"
                                          />
                                        </template>
                                        <template v-else>
                                          <v-icon
                                            size="48"
                                            class="mx-3"
                                            color="primary"
                                          >
                                            mdi-credit-card-outline
                                          </v-icon>
                                        </template>
                                        <v-col>
                                          <span
                                            >{{
                                              item.funding === 'credit'
                                                ? 'Crédito'
                                                : 'Débito'
                                            }}
                                            {{ item.brand }}</span
                                          >
                                          <br />
                                          <span class="cardText"
                                            >**** **** ****
                                            {{ item.last4 }}</span
                                          >
                                        </v-col>
                                      </v-row>
                                    </v-card>
                                    <v-divider />
                                  </template>
                                </v-select-legacy>
                                <v-col cols="12" class="pa-0 ma-0">
                                  <v-row no-gutters>
                                    <v-col cols="7">
                                      <v-card height="70px" width="300px" flat>
                                        <span
                                          class="red--text caption align-text"
                                          v-if="errors.subscriptionError"
                                        >
                                          <v-icon
                                            color="red"
                                            size="18"
                                            class="pb-1"
                                          >
                                            mdi-alert-circle
                                          </v-icon>
                                          {{
                                            $t(
                                              'message.pages.checkout.errors.subscriptionError'
                                            )
                                          }}
                                        </span>
                                      </v-card>
                                    </v-col>
                                    <v-col cols="5">
                                      <v-btn text @click="handleAddCard">
                                        <v-icon color="primary" class="mr-2"
                                          >mdi-plus-circle-outline</v-icon
                                        >
                                        {{ $t('message.addCard') }}
                                      </v-btn>
                                    </v-col>
                                  </v-row>
                                </v-col>
                              </template>
                            </v-card>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="8">
                        <v-row no-gutters align="center">
                          <span>Resumo da compra</span>
                        </v-row>
                      </v-col>
                      <v-col cols="8">
                        <v-row
                          no-gutters
                          align="center"
                          justify="space-between"
                          class="caption mt-2"
                        >
                          <span>Plano</span>
                          <span>R$ {{ plan.price }}</span>
                        </v-row>
                      </v-col>
                      <v-col cols="8">
                        <v-row
                          no-gutters
                          align="center"
                          justify="space-between"
                          class="caption"
                        >
                          <span>Adicionais</span>
                          <span>R$ {{ addonsPrice }}</span>
                        </v-row>
                      </v-col>
                      <v-col cols="8">
                        <v-divider class="my-2" />
                        <v-row
                          no-gutters
                          align="center"
                          justify="space-between"
                        >
                          <span>Total</span>
                          <span>{{
                            this.addonsPrice > 1
                              ? `R$${Number(
                                  parseFloat(plan.price) + addonsPrice
                                )}`
                              : `R$${plan.price}`
                          }}</span>
                        </v-row>
                      </v-col>
                      <v-col cols="8" class="pt-4">
                        <v-row>
                          <v-col cols="12" class="pb-1">
                            <v-btn
                              block
                              color="primary"
                              large
                              :loading="isFetchingCheckout"
                              :disabled="isFetchingCheckout"
                              @click="handleCheckout"
                              >{{ $t('message.finishBuy') }}</v-btn
                            >
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="8" class="my-4">
                        <v-row no-gutters justify="center" align="center">
                          <v-icon class="mr-1" color="icon" small
                            >mdi-lock</v-icon
                          >
                          <span class="safeText">{{
                            $t('message.pages.checkout.safePayment')
                          }}</span>
                        </v-row>
                      </v-col>
                    </template>
                  </template>
                  <template v-else>
                    <v-card
                      class="d-flex flex-row justify-center align-center"
                      height="700px"
                      width="100%"
                    >
                      <v-row no-gutters justify="center" align="center">
                        <v-col
                          cols="8"
                          class="d-flex justify-center align-center mb-3"
                        >
                          <span class="text-h5">{{
                            $t('message.pages.checkout.failedToFetch')
                          }}</span>
                        </v-col>
                        <v-col cols="12">
                          <v-row no-gutters align="center" justify="center">
                            <v-btn
                              color="primary"
                              class="ma-2 ml-3 white--text"
                              rounded
                              @click="handleFetchData"
                            >
                              <span class="mx-2">{{
                                $t('message.tryAgain')
                              }}</span>
                              <v-icon right dark> mdi-cached </v-icon>
                            </v-btn>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-card>
                  </template>
                </template>
                <template v-else>
                  <v-card
                    class="d-flex flex-row justify-center align-center"
                    height="700px"
                    width="100%"
                  >
                    <v-progress-circular
                      :size="80"
                      color="primary"
                      indeterminate
                    ></v-progress-circular>
                  </v-card>
                </template>
              </v-row>
            </template>
            <template v-else>
              <v-card width="100%" height="700px">
                <v-toolbar elevation="0">
                  <v-spacer></v-spacer>
                  <v-toolbar-items>
                    <v-btn icon @click="handleClose" class="mr-2">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-toolbar-items>
                </v-toolbar>
                <v-card-text
                  class="d-flex align-center justify-center flex-column"
                >
                  <v-col cols="8" class="d-flex justify-center align-center">
                    <v-card flat height="350px" width="420px">
                      <img class="mt-10" src="@/assets/purchaseSuccess.svg" />
                    </v-card>
                  </v-col>
                  <v-col cols="12" class="d-flex justify-center align-center">
                    <span class="planSuccess pr-16 mr-10"
                      >{{
                        $t('message.pages.checkout.successPlanAcquired')
                      }}!</span
                    >
                  </v-col>
                  <v-col cols="12" class="d-flex justify-center align-center">
                    <span class="planSuccessSubtitle mb-4"
                      >{{ $t('message.pages.checkout.planActive') }} <br />
                      {{ $t('message.pages.checkout.seeInDashboard') }}.</span
                    >
                  </v-col>
                  <v-col cols="8" class="d-flex justify-center align-center">
                    <v-row class="pl-4">
                      <v-col cols="12">
                        <v-btn
                          elevation="0"
                          color="#EFEFFD"
                          large
                          block
                          @click="handleVideos"
                          >{{ $t('message.concluded') }}</v-btn
                        >
                      </v-col>
                    </v-row>
                  </v-col>
                </v-card-text>
              </v-card>
            </template>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { STRIPE_API } from '../../config/envs'
import planApi from '../../services/planApi'
import addressApi from '../../services/addressApi'
import { mapMutations, mapState } from 'vuex'
import { StripeElementCard } from '@vue-stripe/vue-stripe'
import { mask } from 'vue-the-mask'
import prettyBytes from 'pretty-bytes'
import i18n from '@/translations/lang'
import { IS_CPF, IS_CNPJ } from '@/config/envs.js'
import CustomizePlan from '../../components/CustomizePlan.vue'

export default {
  name: 'Checkout',
  components: {
    StripeElementCard,
    CustomizePlan,
  },
  directives: { mask },
  data: () => ({
    open: false,
    aditionalStep: true,
    showPlansCard: true,
    stepper: {
      step: 0,
    },
    isFetching: false,
    isFetchingCheckout: false,
    isFetchingAddress: false,
    isFetchingUserDetails: false,
    cardEditing: false,
    card: {},
    cards: [],
    newCard: false,
    hasAddress: false,
    hasTaxid: false,
    owner: {
      document: '',
      name: '',
      phone: '',
      address: {
        city: '',
        country: 'BR',
        line1: '',
        line2: '',
        postal_code: '',
        state: '',
      },
    },
    step: 1,
    stripeKey: process.env.VUE_APP_STRIPE_API,
    stripeKeyUS: process.env.VUE_APP_STRIPE_API_US,
    plan: {
      title: '',
      price: '',
      prices: [],
      storage: '',
      traffic: '',
      value: '',
      id: '',
    },
    cardToken: '',
    purchaseDone: false,
    purchaseFailed: false,
    validatingCEP: false,
    cardErrors: {
      declined: false,
      default: false,
      expired: false,
    },
    errors: {
      invalidCpf: false,
      invalidCnpj: false,
      addressError: false,
      subscriptionError: false,
      userDataError: false,
      cardInfoError: false,
    },
    unknownErrorMsg: '',
    states: [
      { id: 12, UF: 'AC', stateName: 'Acre' },
      { id: 27, UF: 'AL', stateName: 'Alagoas' },
      { id: 16, UF: 'AP', stateName: 'Amapá' },
      { id: 13, UF: 'AM', stateName: 'Amazonas' },
      { id: 29, UF: 'BA', stateName: 'Bahia' },
      { id: 23, UF: 'CE', stateName: 'Ceará' },
      { id: 53, UF: 'DF', stateName: 'Distrito Federal' },
      { id: 32, UF: 'ES', stateName: 'Espírito Santo' },
      { id: 52, UF: 'GO', stateName: 'Goiás' },
      { id: 21, UF: 'MA', stateName: 'Maranhão' },
      { id: 51, UF: 'MT', stateName: 'Mato Grosso' },
      { id: 50, UF: 'MS', stateName: 'Mato Grosso do Sul' },
      { id: 31, UF: 'MG', stateName: 'Minas Gerais' },
      { id: 15, UF: 'PA', stateName: 'Pará' },
      { id: 25, UF: 'PB', stateName: 'Paraíba' },
      { id: 41, UF: 'PR', stateName: 'Paraná' },
      { id: 26, UF: 'PE', stateName: 'Pernambuco' },
      { id: 22, UF: 'PI', stateName: 'Piauí' },
      { id: 33, UF: 'RJ', stateName: 'Rio de Janeiro' },
      { id: 24, UF: 'RN', stateName: 'Rio Grande do Norte' },
      { id: 43, UF: 'RS', stateName: 'Rio Grande do Sul' },
      { id: 11, UF: 'RO', stateName: 'Rondônia' },
      { id: 14, UF: 'RR', stateName: 'Roraima' },
      { id: 42, UF: 'SC', stateName: 'Santa Catarina' },
      { id: 35, UF: 'SP', stateName: 'São Paulo' },
      { id: 28, UF: 'SE', stateName: 'Sergipe' },
      { id: 17, UF: 'TO', stateName: 'Tocantins' },
    ],
    addons: {
      storage: {
        addonAdicionalStorage: 0,
        price: 0,
      },
      traffic: {
        addonAdicionalTraffic: 0,
        price: 0,
      },
    },
  }),
  mounted() {
    this.$root.$on('CheckoutModal', async (plan) => {
      Object.assign(this.$data, this.initialState())
      this.isFetching = true
      this.plan = plan
      this.open = true

      this.$refs.elementRef && this.$refs.elementRef.clear()
      const [userInfo, cardsInfo] = await Promise.all([
        this.getUserData(),
        this.getCards(),
      ])

      this.owner.name = userInfo.data.name
      if (userInfo.data.phone) this.owner.phone = userInfo.data.phone
      if (userInfo.data.taxId.value)
        this.owner.document = userInfo.data.taxId.value
      this.hasTaxid =
        userInfo.data.taxId && userInfo.data.name && userInfo.data.phone
      this.hasAddress = userInfo.data.address
      this.customer_id = userInfo.data.id
      if (userInfo.data.address) this.owner.address = userInfo.data.address

      const card = cardsInfo.data.cards.find((item) => item.default === true)
      this.cards = cardsInfo.data.cards
      if (card) this.card = card
      if (cardsInfo.data.cards.length === 0) this.newCard = true

      this.stepper.step = 0
      if (this.hasTaxid) this.stepper.step = 1
      this.isFetching = false
    })
    this.$root.$on('updateAddons', (addons) => {
      this.addons = addons
    })
    this.$root.$on('finishAddons', () => {
      this.aditionalStep = false
      this.handleProhata()
    })
  },
  watch: {
    open(v) {
      v
        ? this.$root.$emit('checkoutOpened')
        : this.$root.$emit('checkoutClosed')
    },
  },
  beforeDestroy() {
    this.$root.$off('CheckoutModal')
  },
  computed: {
    ...mapState({
      products: (state) => state.user.products,
      userPlanInfo: (state) => state.user.userPlanInfo,
    }),
    addonsPrice() {
      return (
        Number(this.addons.storage.price) + Number(this.addons.traffic.price)
      )
    },
    pulishableKey() {
      return STRIPE_API
    },
    firstStepForm() {
      if (this.owner.document) {
        const doc = this.unmask(this.owner.document)
        return (
          this.owner.name &&
          this.owner.phone &&
          doc.length > 10 &&
          !(doc.length === 13) &&
          !(doc.length === 12)
        )
      }
      return false
    },
    secondStepForm() {
      return (
        !!this.owner.address.postal_code &&
        !!this.owner.address.line1 &&
        !!this.owner.address.city &&
        !!this.owner.address.state
      )
    },
    documentErrorMessage() {
      if (this.errors.invalidCpf) {
        return 'CPF inválido'
      }
      if (this.errors.invalidCnpj) {
        return 'CNPJ inválido'
      }
      return ''
    },
    cardErrorMsg() {
      if (this.cardErrors.declined) {
        return i18n.t('message.pages.checkout.errors.refusedCard')
      }
      if (this.cardErrors.expired) {
        return i18n.t('message.pages.checkout.errors.invalidCard')
      }
      if (this.cardErrors.default) {
        return i18n.t('message.pages.checkout.errors.defaultCardError')
      }
      return ''
    },
    backButtonText() {
      if (!this.aditionalStep) {
        return i18n.t('message.pages.checkout.previousStep')
      }
      return i18n.t('message.pages.checkout.backToPlans')
    },
  },
  methods: {
    ...mapMutations('user', ['UPDATE_USER_PLAN_INFO']),
    async handleProhata() {
      try {
        let items = [
          {
            price: this.plan.prices[0].id,
            quantity: 1,
          },
        ]
        if (this.addons.storage.addonAdicionalStorage > 1) {
          let storageAddon = this.products.addons.find((addon) => {
            let capitalizedName = addon.name.toUpperCase()
            return capitalizedName.includes('STORAGE')
          })
          let storagePriceId = storageAddon.prices[4].id
          let storageAddonItem = {
            price: storagePriceId,
            quantity: Math.round(
              this.addons.storage.addonAdicionalStorage / 100
            ),
          }
          items.push(storageAddonItem)
        }
        await planApi.previewInvoice(this.userPlanInfo.subscription_id, items)
      } catch (e) {
        console.error(e)
      }
    },
    handleBackButton() {
      if (this.aditionalStep) {
        this.handleClose()
      } else {
        if (this.stepper.step === 0 || this.stepper.step === 1) {
          this.aditionalStep = true
        }
        if (this.stepper.step === 2) {
          this.stepper.step = 1
        }
      }
      return
    },
    handleDocumentValidate() {
      Object.keys(this.errors).forEach((e) => (this.errors[e] = false))
      const doc = this.unmask(this.owner.document)
      if (doc.length === IS_CPF) {
        this.errors.invalidCpf = !this.isValidCPF(doc)
      }
      if (doc.length === IS_CNPJ) {
        this.errors.invalidCnpj = !this.isValidCNPJ(doc)
      }
    },
    async handleCheckout() {
      Object.keys(this.errors).forEach((e) => (this.errors[e] = false))
      this.isFetchingCheckout = true
      if (this.newCard) {
        await this.submit()
      } else {
        await this.subscribeToPlan()
        await planApi.getSubscription(true)
      }
      this.$root.$emit('refreshUserPlan')
    },
    handleAddCard() {
      Object.keys(this.cardErrors).forEach((e) => (this.cardErrors[e] = false))
      this.newCard = true
    },
    handleCancelAddCard() {
      Object.keys(this.cardErrors).forEach((e) => (this.cardErrors[e] = false))
      this.newCard = false
    },
    async getUserData() {
      try {
        const ret = await planApi.getSubscription()
        return ret
      } catch (e) {
        this.errors.userDataError = true
      }
    },
    async getCards() {
      try {
        const ret = await planApi.getCards()
        return ret
      } catch (e) {
        this.errors.cardInfoError = true
      }
    },
    async submit() {
      // this will trigger the process
      await this.$refs.elementRef.submit()
    },
    async handleToken(token) {
      this.isFetchingCheckout = true
      this.cardToken = token
      try {
        await this.addCardToUser(token)
      } catch (error) {
        this.isFetchingCheckout = false
        console.log(error)
      }
    },
    async addUserToStripe() {
      this.isFetchingUserDetails = true
      Object.keys(this.errors).forEach((e) => (this.errors[e] = false))
      const doc = this.unmask(this.owner?.document)
      if (!doc || (doc?.length !== IS_CNPJ && doc?.length !== IS_CPF)) {
        this.errors.invalidCpf = true
        this.isFetchingUserDetails = false
        return
      }
      if (doc?.length === IS_CPF) {
        const isValid = this.isValidCPF(doc)
        if (!isValid) {
          this.errors.invalidCpf = true
          this.isFetchingUserDetails = false
          return
        }
      }
      if (doc?.length === IS_CNPJ) {
        const isValidCNPJ = this.isValidCNPJ(doc)
        if (!isValidCNPJ) {
          this.errors.invalidCnpj = true
          this.isFetchingUserDetails = false
          return
        }
      }
      try {
        const type =
          this.unmask(this.owner.document).length === IS_CPF
            ? 'br_cpf'
            : 'br_cnpj'
        await planApi.updateAddress({
          tax_obj: {
            type,
            value: this.unmask(this.owner.document),
          },
          phone: this.owner.phone,
          name: this.owner.name,
        })
        this.stepper.step = 1
      } catch (e) {
        console.error(e)
      }
      this.isFetchingUserDetails = false
    },
    async addAddressToUser() {
      this.isFetchingAddress = true
      try {
        const unmaskedAddress = {
          ...this.owner.address,
          postal_code: this.unmask(this.owner.address.postal_code),
        }
        await planApi.updateAddress({
          address: unmaskedAddress,
        })
        this.stepper.step = 2
      } catch (e) {
        this.errors.addressError = true
      }
      this.isFetchingAddress = false
    },
    async addCardToUser(cardToken) {
      Object.keys(this.cardErrors).forEach((e) => (this.cardErrors[e] = false))
      try {
        await planApi.addCard(cardToken)
        await this.subscribeToPlan()
      } catch (e) {
        this.isFetchingCheckout = false
        switch (e.response.data.errMsg) {
          case 'card_declined':
            this.cardErrors.declined = true
            break
          case 'expired_card':
            this.cardErrors.expired = true
            break
          default:
            this.cardErrors.default = true
            break
        }
      }
    },
    async changeDefaultCard(card) {
      try {
        const ret = await planApi.changeDefaultCard(card)
        return ret
      } catch (e) {
        this.errors.cardInfoError = true
      }
    },
    async subscribeToPlan() {
      try {
        const res = await this.changeDefaultCard(this.card.id)
        const evalRet = !!res.data
        if (!evalRet) {
          this.isFetchingCheckout = false
          return
        }
        const ret = await planApi.subscribeToPlan(this.plan.value)
        await this.addAddons()
        this.$root.$emit('refreshUserPlan')
        if (ret.data.message) {
          this.purchaseDone = true
        }
      } catch (e) {
        this.errors.subscriptionError = true
      }
      this.isFetchingCheckout = false
    },
    async addAddons() {
      try {
        await planApi.addStorage(this.addons.storage.addonAdicionalStorage)
      } catch (e) {
        console.error(e)
      }
    },
    async handleDeleteCard(cardId) {
      try {
        await planApi.deleteCard(cardId)
      } catch (e) {
        console.log(e)
      }
    },
    handleEditCards() {
      this.cardEditing = true
    },
    handleClose() {
      this.open = false
    },
    async searchCep() {
      this.validatingCEP = true
      const cepNumber = this.unmask(this.owner.address.postal_code)
      if (cepNumber.length === 8) {
        try {
          const ret = await addressApi.getCep(cepNumber)
          this.owner.address.line1 = ret.data.address
          this.owner.address.city = ret.data.name
          const stateFound = this.states.filter((state) => {
            return state.id === ret.data.state_id
          })
          this.owner.address.state = stateFound[0].UF
        } catch (e) {
          console.error(e)
        }
      }
      this.validatingCEP = false
    },
    unmask(text) {
      const defaultDelimiters = /[-!$%^&*()_+|~=`{}[\]:";'<>?,./\\ ]/
      return text
        ? String(text).replace(new RegExp(defaultDelimiters, 'g'), '')
        : text
    },
    calcBytes(planStorage) {
      let bytes = 0
      planStorage > 1024
        ? (bytes = (planStorage / 1024) * 1e12)
        : (bytes = planStorage * 1e9)
      return `${prettyBytes(bytes, { maximumFractionDigits: 0 })}`
    },
    isValidCPF(cpf) {
      if (typeof cpf !== 'string') return false
      cpf = cpf.replace(/[^\d]+/g, '')
      if (cpf.length !== IS_CPF || !!cpf.match(/(\d)\1{10}/)) return false
      cpf = cpf.split('')
      const validator = cpf
        .filter((digit, index, array) => index >= array.length - 2 && digit)
        .map((el) => +el)
      const toValidate = (pop) =>
        cpf
          .filter((digit, index, array) => index < array.length - pop && digit)
          .map((el) => +el)
      const rest = (count, pop) =>
        ((toValidate(pop).reduce((soma, el, i) => soma + el * (count - i), 0) *
          10) %
          11) %
        10
      return !(rest(10, 2) !== validator[0] || rest(11, 1) !== validator[1])
    },
    isValidCNPJ(cnpj) {
      if (
        !cnpj ||
        cnpj.length != 14 ||
        cnpj == '00000000000000' ||
        cnpj == '11111111111111' ||
        cnpj == '22222222222222' ||
        cnpj == '33333333333333' ||
        cnpj == '44444444444444' ||
        cnpj == '55555555555555' ||
        cnpj == '66666666666666' ||
        cnpj == '77777777777777' ||
        cnpj == '88888888888888' ||
        cnpj == '99999999999999'
      )
        return false
      let tamanho = cnpj.length - 2
      let numeros = cnpj.substring(0, tamanho)
      let digitos = cnpj.substring(tamanho)
      let soma = 0
      let pos = tamanho - 7
      for (let i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--
        if (pos < 2) pos = 9
      }
      let resultado = soma % IS_CPF < 2 ? 0 : 11 - (soma % IS_CPF)
      if (resultado != digitos.charAt(0)) return false
      tamanho = tamanho + 1
      numeros = cnpj.substring(0, tamanho)
      soma = 0
      pos = tamanho - 7
      for (let i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--
        if (pos < 2) pos = 9
      }
      resultado = soma % IS_CPF < 2 ? 0 : IS_CPF - (soma % IS_CPF)
      if (resultado != digitos.charAt(1)) return false
      return true
    },
    async handleFetchData() {
      Object.keys(this.errors).forEach((e) => (this.errors[e] = false))
      this.isFetching = true
      const [userInfo, cardsInfo] = await Promise.all([
        this.getUserData(),
        this.getCards(),
      ])

      this.owner.name = userInfo.data.name
      this.owner.document = userInfo.data.taxId.value
      this.hasTaxid = userInfo.data.taxId && userInfo.data.name
      this.hasAddress = userInfo.data.address
      if (userInfo.data.address) this.owner.address = userInfo.data.address

      const card = cardsInfo.data.cards.find((item) => item.default === true)
      this.cards = cardsInfo.data.cards
      if (card) this.card = card
      if (cardsInfo.data.cards.length === 0) this.newCard = true

      this.stepper.step = 0
      if (this.hasTaxid) this.stepper.step = 1
      this.isFetching = false
    },
    handleVideos() {
      this.$router.push({ name: 'Videos' })
      this.handleClose()
      this.$root.$emit('closeUpgrade')
    },
    initialState() {
      return {
        open: false,
        aditionalStep: true,
        stepper: {
          step: 0,
        },
        isFetching: false,
        isFetchingCheckout: false,
        isFetchingAddress: false,
        isFetchingUserDetails: false,
        cardEditing: false,
        card: {},
        cards: [],
        newCard: false,
        hasAddress: false,
        hasTaxid: false,
        owner: {
          document: '',
          name: '',
          phone: '',
          address: {
            city: '',
            country: 'BR',
            line1: '',
            line2: '',
            postal_code: '',
            state: '',
          },
        },
        step: 1,
        stripeKey: process.env.VUE_APP_STRIPE_API,
        stripeKeyUS: process.env.VUE_APP_STRIPE_API_US,
        plan: {
          title: '',
          price: '',
          storage: '',
          traffic: '',
          value: '',
        },
        cardToken: '',
        purchaseDone: false,
        purchaseFailed: false,
        validatingCEP: false,
        cardErrors: {
          declined: false,
          default: false,
          expired: false,
        },
        errors: {
          invalidCpf: false,
          invalidCnpj: false,
          addressError: false,
          subscriptionError: false,
          userDataError: false,
          cardInfoError: false,
        },
        unknownErrorMsg: '',
        states: [
          { id: 12, UF: 'AC', stateName: 'Acre' },
          { id: 27, UF: 'AL', stateName: 'Alagoas' },
          { id: 16, UF: 'AP', stateName: 'Amapá' },
          { id: 13, UF: 'AM', stateName: 'Amazonas' },
          { id: 29, UF: 'BA', stateName: 'Bahia' },
          { id: 23, UF: 'CE', stateName: 'Ceará' },
          { id: 53, UF: 'DF', stateName: 'Distrito Federal' },
          { id: 32, UF: 'ES', stateName: 'Espírito Santo' },
          { id: 52, UF: 'GO', stateName: 'Goiás' },
          { id: 21, UF: 'MA', stateName: 'Maranhão' },
          { id: 51, UF: 'MT', stateName: 'Mato Grosso' },
          { id: 50, UF: 'MS', stateName: 'Mato Grosso do Sul' },
          { id: 31, UF: 'MG', stateName: 'Minas Gerais' },
          { id: 15, UF: 'PA', stateName: 'Pará' },
          { id: 25, UF: 'PB', stateName: 'Paraíba' },
          { id: 41, UF: 'PR', stateName: 'Paraná' },
          { id: 26, UF: 'PE', stateName: 'Pernambuco' },
          { id: 22, UF: 'PI', stateName: 'Piauí' },
          { id: 33, UF: 'RJ', stateName: 'Rio de Janeiro' },
          { id: 24, UF: 'RN', stateName: 'Rio Grande do Norte' },
          { id: 43, UF: 'RS', stateName: 'Rio Grande do Sul' },
          { id: 11, UF: 'RO', stateName: 'Rondônia' },
          { id: 14, UF: 'RR', stateName: 'Roraima' },
          { id: 42, UF: 'SC', stateName: 'Santa Catarina' },
          { id: 35, UF: 'SP', stateName: 'São Paulo' },
          { id: 28, UF: 'SE', stateName: 'Sergipe' },
          { id: 17, UF: 'TO', stateName: 'Tocantins' },
        ],
        addons: {
          storage: {
            addonAdicionalStorage: 0,
            price: 0,
          },
          traffic: {
            addonAdicionalTraffic: 0,
            price: 0,
          },
        },
      }
    },
  },
}
</script>

<style lang="scss">
@import '~vuetify/src/components/VStepper/_variables.scss';

.selectTemplate2 .v-input__control .v-input__slot {
  padding: 0px !important;
}

.selectTemplate .v-list {
  padding: 0px;
}

.selectTemplate .v-list .v-list-item {
  padding: 0px;
}

.v-stepper__step__step {
  height: 12px !important;
  width: 12px !important;
  min-width: 12px !important;
}

.cardTitle {
  font-weight: 600;
  font-size: 20px;
  line-height: 32px;
}

.subtitleText {
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  letter-spacing: 0.08em;
  color: #878787;
}

.sectionText {
  font-size: 14px;
  line-height: 12px;
  letter-spacing: 0.08em;
  color: #2f2f2f;
}

.safeText {
  font-size: 10px;
  line-height: 14px;
  color: #878787;
}

.cardPlanText {
  font-weight: 400;
  font-size: 24px;
  line-height: 36px;
  color: #ffffff;
}

.planText {
  font-weight: 500;
  font-size: 18px;
  line-height: 10px;
  letter-spacing: 0.08em;
  color: #2f2f2f;
}

.cardPriceText {
  font-weight: 500;
  font-size: 18px;
  line-height: 32px;
  color: #4874f1;
}

.cardByTime {
  font-size: 11px;
  line-height: 16px;
  letter-spacing: 0.05em;
  color: #d6d6d6;
}

.cardPlanAttributes {
  font-size: 14px;
  line-height: 12px;
  letter-spacing: 0.08em;
  color: #878787;
}

.cardText {
  font-size: 11px;
  line-height: 16px;
  letter-spacing: 0.05em;
  color: #878787;
}

.planSuccess {
  font-size: 22px;
  font-weight: 500;
  line-height: 32px;
}

.planSuccessSubtitle {
  font-size: 16px;
  line-height: 26px;
  letter-spacing: 0.08em;
}

.illustration-container {
  width: 100%;
  height: 100%;
  background: linear-gradient(155.2deg, #5d85f8 19%, #405eb6 122.33%);
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.circle-top {
  position: absolute;
  top: 0;
  right: 0;
}
.circle-bottom {
  position: absolute;
  transform: rotate(180deg);
  bottom: 0;
  left: 0;
}
.illustration-img {
  z-index: 10;
  width: 80%;
  max-width: 500px;
}
.dots-vertical {
  position: absolute;
  top: 30px;
  left: 90px;
}

.dots-horizontal {
  position: absolute;
  transform: rotate(90deg);
  bottom: 35%;
  left: 80px;
}
</style>
